/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useState } from "react";
import Layout from "components/layout";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
  Button,
  Card,
  CardContent,
  CardDescription,
  CardTitle,
  Combobox,
  DatePicker,
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
  RadioGroup,
  RadioGroupItem,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  Textarea,
} from "@repo/ui";
import {
  useGetRoutes,
  useAutocompleteKiosks,
  useGetCustomers,
  useGetCustomerCITList,
  useGetServiceTypes,
  useAutocompleteCIT,
  useAutocompleteHolding,
  useGetCashCenters,
  useAutocompleteInterBranchCIT,
} from "utils/apis/lookups.api";
import { zodResolver } from "@hookform/resolvers/zod";
import type { UseFormReturn } from "react-hook-form";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { format } from "date-fns";
import { PREV_5_DAY_DATE } from "utils/constant";
import { Link } from "react-router-dom";
import { useCreateOrder } from "utils/apis/manage-all-orders.api";
import ReplenishModelDenominations from "./replenish-model-denominations";
import SearchableDropdown from "components/searchableDropdown";
import { showToast } from "utils/helper";

const jobPriorities = [
  { value: "1", name: "Critical" },
  { value: "2", name: "High" },
  { value: "3", name: "Normal" },
  { value: "4", name: "Low" },
];
const jobNatures = [
  { value: "Normal", name: "Normal" },
  { value: "Adhoc", name: "Adhoc" },
  { value: "Special Service", name: "Special Service" },
];

const invoicingModels = [
  { value: "Fixed", name: "Fixed" },
  { value: "Dedicated", name: "Dedicated" },
  { value: "Service", name: "Service" },
];

const formSchema = z
  .object({
    customerId: z
      .string()
      .min(1, { message: "Customer is required." })
      .optional(),
    servicePointId: z.string().optional(),
    serviceDateTime: z.date({
      required_error: "Service date is required.",
    }),
    serviceType: z.string().min(1, { message: "Service Type is required." }),
    customerName: z.string().optional(),
    source: z.string().optional(),
    isPrepack: z.boolean().default(false),
    isBranchToATM: z.boolean().default(false),
    isBranchToATMUndefinedLocation: z.boolean().default(false),
    isBinClearance: z.boolean().optional(),
    invoicingModel: z.string(),
    priority: z.string(),
    jobNature: z.string(),
    shift: z.string().min(1, { message: "Shift is required." }),
    jobType: z.string().min(1, { message: "Job Type is required." }),
    requestedBy: z.string().min(1, { message: "Requested By is required." }),
    sourceSPId: z.string().optional(),
    onwardSPId: z.string().optional(),
    onwardCustomerName: z.string().optional(),
    routeNo: z.string().optional(),
    remarks: z.string().optional(),
    createType: z.string().optional(),
    barcode: z.string().optional(),
    onwardCashCenterId: z.string().optional(),
  })
  .superRefine((data, ctx) => {
    if (["B2B Service", "Interbranch Service"].includes(data.serviceType)) {
      if (!data.sourceSPId) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Source Location is required.",
          path: ["sourceSPId"],
        });
      }

      if (!data.onwardSPId) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Onward Location is required.",
          path: ["onwardSPId"],
        });
      }

      if (
        data.serviceType === "Interbranch Service" &&
        !data.onwardCashCenterId
      ) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Onward Cash Center is required.",
          path: ["onwardCashCenterId"],
        });
      }
    } else {
      if (
        !data.isPrepack &&
        (!data.servicePointId || data.servicePointId.trim() === "")
      ) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Location is required.",
          path: ["servicePointId"],
        });
      }
      if (
        data.isBranchToATM &&
        (!data.sourceSPId || data.sourceSPId.trim() === "")
      ) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Bank Branch is required.",
          path: ["sourceSPId"],
        });
      }
    }
  });

export default function CreateAllOrders() {
  const [sourceLocation, setSourceLocation] = useState<any>(null);
  const [onwardLocation, setOnwardLocation] = useState<any>(null);
  const [cassettes, setCassettes] = useState<any[]>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [onwardSearch, setOnwardSearch] = useState("");
  const [orderType, setOrderType] = useState("default");

  const { data: cashCenters } = useGetCashCenters();
  const { data: serviceTypes } = useGetServiceTypes();
  const { data: inRouteTeams } = useGetRoutes();
  const { data: customerList } = useGetCustomers();

  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      serviceType: "",
      customerId: "",
      servicePointId: "",
      isPrepack: false,
      serviceDateTime: new Date(),
      isBinClearance: false, // boolean default
      invoicingModel: "Service",
      priority: "2",
      shift: "morning",
      jobNature: "Normal",
      jobType: "",
      routeNo: "",
      requestedBy: "",
      remarks: "",
      customerName: "",
      isBranchToATM: false,
      isBranchToATMUndefinedLocation: false,
      sourceSPId: "",
      onwardSPId: "",
      onwardCustomerName: "",
      onwardCashCenterId: "",
    },
  });

  const serviceType = form.watch("serviceType");
  const customerId = form.watch("customerId");
  const isHolding = form.watch("jobType") === "Holding";
  const isInterBrachService = serviceType?.startsWith("Inter");
  const onwardCashCenterId = form.watch("onwardCashCenterId");

  const { data: autocompleteResults, isFetching: isFetchingLocations } =
    useAutocompleteKiosks(serviceType === "Kiosk Service" ? searchTerm : "");
  const { data: sourceLocations, isFetching: isFetchingAutocomplete } =
    useAutocompleteCIT(serviceType !== "Kiosk Service" ? searchTerm : "");
  const { data: customerCITList } = useGetCustomerCITList(customerId || "");
  const { data: holdingList, isFetching: isFetchingHolding } =
    useAutocompleteHolding(
      isHolding && !isInterBrachService ? onwardSearch : "",
    );
  const { data: onwardLocations, isFetching: isFetchingOnward } =
    useAutocompleteCIT(!isHolding && !isInterBrachService ? onwardSearch : "");
  const { data: ibOnwardLocations, isFetching: isFetchingIbOnward } =
    useAutocompleteInterBranchCIT(
      isInterBrachService ? onwardSearch : "",
      onwardCashCenterId,
    );

  const isPrepack = form.watch("isPrepack");
  const isBranchToATM = form.watch("isBranchToATM");
  const isBranchToATMUndefinedLocation = form.watch(
    "isBranchToATMUndefinedLocation",
  );
  const jobTypes = serviceTypes?.find(
    (i) => i.description === serviceType,
  )?.jobTypes;

  // mutations
  const {
    mutate: createOrder,
    isSuccess: isOrderSuccess,
    isPending: isOrderPending,
    isError: isOrderError,
    reset: orderReset,
  } = useCreateOrder();

  const mappedLocations =
    autocompleteResults?.map((item: any) => ({
      value: item.servicePointId,
      label: `${item.barcode || ""}-${item.locationId}`,
    })) || [];

  const handleOrderType = (value: string) => {
    setOrderType(value);
    if (value === "Pre Pack") {
      form.setValue("isPrepack", true);
      form.setValue("servicePointId", "");
      form.setValue("customerId", "");
      form.setValue("customerName", "");
      form.setValue("barcode", "");
      setSearchTerm("");
      setOnwardSearch("");
      setSourceLocation(null);
    } else {
      form.setValue("isPrepack", false);
    }
    if (value === "Branch To ATM") {
      form.setValue("isBranchToATM", true);
    } else {
      form.setValue("isBranchToATM", false);
      form.setValue("sourceSPId", "");
    }

    if (value === "Branch To ATM Undefined Location") {
      form.setValue("isBranchToATMUndefinedLocation", true);
    } else {
      form.setValue("isBranchToATMUndefinedLocation", false);
    }
  };

  const handleChangeServiceType = () => {
    form.resetField("jobType");
    form.resetField("servicePointId");
    form.resetField("onwardSPId");
    form.resetField("sourceSPId");
    setSearchTerm("");
    setOnwardSearch("");
  };

  const onCITSourceLocationChanged = (value: string) => {
    const destSpId = onwardLocation?.servicePointId;
    if (destSpId && String(destSpId) === String(value)) {
      showToast(
        "error",
        "Source and destination locations cannot be the same.",
      );
      form.setValue("sourceSPId", "");
      form.setValue("customerName", "");
      form.setValue("customerId", "");
      setSourceLocation(null);
      return;
    }

    form.setValue("servicePointId", value);
    setSourceLocation(null);
    const sp = sourceLocations?.find((s: any) => s.servicePointId === value);
    if (sp) {
      setSourceLocation(sp);
      form.setValue("customerName", String(sp.customer));
      form.setValue("customerId", String(sp.customerId));
    }
  };

  const onSourceLocationChanged = (value: string) => {
    const sp = autocompleteResults?.find(
      (s: any) => s.servicePointId === value,
    );

    form.setValue("sourceSPId", value);
    setSourceLocation(null);

    if (sp) {
      setSourceLocation(sp);
      form.setValue("customerName", String(sp.customer));
      form.setValue("customerId", String(sp.customerId));
    }
  };

  const onOnwardLocationChanged = (value: string) => {
    const sourceSpId =
      sourceLocation?.servicePointId || form.getValues("sourceSPId");
    if (sourceSpId && String(sourceSpId) === String(value)) {
      showToast(
        "error",
        "Source and destination locations cannot be the same.",
      );
      form.setValue("onwardSPId", "");
      setOnwardLocation(null);

      return;
    }

    const selectedSP = (isHolding ? holdingList : onwardLocations)?.find(
      (item: any) => item?.servicePointId === value,
    );

    if (selectedSP) {
      setOnwardLocation(selectedSP);
      form.setValue("onwardCustomerName", String(selectedSP.customer));
    }
  };

  // clear and reset states when a request completes or createType changes
  useEffect(() => {
    if (isOrderSuccess) {
      form.reset();
      orderReset();
      handleOrderType("default");
      setSourceLocation(null);
      setCassettes([]);
      setSearchTerm("");
      setOnwardSearch("");
    }
    if (isOrderError) {
      orderReset();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOrderSuccess, isOrderError]);

  // submit handler
  function onSubmit(values: z.infer<typeof formSchema>) {
    const denominations: any[] = [];
    const dateWithCurrentTime = new Date().setDate(
      new Date(values.serviceDateTime).getDate(),
    );

    if (cassettes.length > 0) {
      cassettes.forEach((cst: any) => {
        if (cst.description === "ATM Cassette") {
          denominations.push({
            denomination: cst.denomination,
            shape: "Notes",
            version: "",
            noOfCassettes: cst.noOfCassettes,
            noOfNotes: cst.noOfNotes,
          });
        }
      });
    }
    delete (values as any).createType;
    delete (values as any).locationIds;

    const requestDto = {
      ...values,
      serviceDateTime: format(
        dateWithCurrentTime,
        "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'",
      ),
      denominations,
    };
    createOrder(requestDto);
  }

  const onwardLocationsData = isInterBrachService
    ? ibOnwardLocations
    : isHolding
      ? holdingList
      : onwardLocations;

  return (
    <Layout>
      <Breadcrumb className="mt-5 mx-4">
        <BreadcrumbList>
          <BreadcrumbItem>
            <Link to="/dashboard">Home</Link>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <Link to="/manage-all-order">Menage All Order</Link>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>Create Request</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>

      <div className="flex mx-4 mt-5 gap-3">
        <Card className="flex-1">
          <CardContent className="pt-6">
            <CardDescription>
              <Form {...form}>
                <form
                  id="collection-form"
                  onSubmit={form.handleSubmit(onSubmit)}
                  className="gap-4 grid grid-cols-2"
                >
                  <FormSelect
                    form={form}
                    data={
                      serviceTypes?.map(({ description }: any) => ({
                        name: description,
                        value: description,
                      })) || []
                    }
                    name="serviceType"
                    label="Service Type"
                    placeholder="Select service type"
                    onChange={handleChangeServiceType}
                  />
                  <FormSelect
                    form={form}
                    data={
                      jobTypes?.map(({ description }: any) => ({
                        name: description,
                        value: description,
                      })) || []
                    }
                    name="jobType"
                    label="Job Type"
                    placeholder="Select Job Type"
                  />
                  {serviceType === "Kiosk Service" && (
                    <RadioGroup
                      className="w-full flex items-center gap-6 col-span-2"
                      orientation="horizontal"
                      onValueChange={handleOrderType}
                      value={orderType}
                    >
                      <label className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
                        Request Type:
                      </label>
                      <div className="flex items-center gap-3">
                        <RadioGroupItem value="default" id="r1" />
                        <label htmlFor="r1">Default</label>
                      </div>
                      <div className="flex items-center gap-3">
                        <RadioGroupItem value="Pre Pack" id="r2" />
                        <label htmlFor="r2">Pre Pack</label>
                      </div>
                      <div className="flex items-center gap-3">
                        <RadioGroupItem value="Branch To ATM" id="r3" />
                        <label htmlFor="r3">Branch To ATM</label>
                      </div>
                      {/* <div className="flex items-center gap-3">
                      <RadioGroupItem
                        value="Branch To ATM Undefined Location"
                        id="r4"
                      />
                      <label htmlFor="r4">
                        Branch To ATM Undefined Location
                      </label>
                    </div> */}
                    </RadioGroup>
                  )}
                  {isPrepack || isBranchToATMUndefinedLocation ? (
                    <FormCombobox
                      form={form}
                      data={customerList?.map((cust: any) => ({
                        value: cust?.customerId,
                        label: cust?.name,
                      }))}
                      name="customerId"
                      label="Customer"
                      placeholder="Select Customer"
                      onChange={() => {
                        form.setValue("sourceSPId", "");
                      }}
                    />
                  ) : (
                    <>
                      {["B2B Service", "Interbranch Service"].includes(
                        serviceType,
                      ) ? (
                        <>
                          <FormField
                            control={form.control}
                            name="sourceSPId"
                            render={({ field }) => (
                              <FormItem>
                                <FormLabel>Source Location</FormLabel>
                                <SearchableDropdown
                                  value={field.value}
                                  searchTerm={searchTerm}
                                  onSearchChange={setSearchTerm}
                                  data={
                                    sourceLocations?.map((item: any) => ({
                                      value: item.servicePointId,
                                      label: `${item.barcode || ""}-${item.locationId}`,
                                    })) || []
                                  }
                                  loading={isFetchingAutocomplete}
                                  onChange={(val) => {
                                    field.onChange(val);
                                    onCITSourceLocationChanged(val);
                                  }}
                                />

                                <FormMessage />
                              </FormItem>
                            )}
                          />
                          <FormField
                            control={form.control}
                            name="customerName"
                            render={({ field }) => (
                              <FormItem>
                                <FormLabel>Source Location Customer</FormLabel>
                                <FormControl>
                                  <Input {...field} readOnly />
                                </FormControl>
                                <FormMessage />
                              </FormItem>
                            )}
                          />

                          <FormField
                            control={form.control}
                            name="onwardSPId"
                            render={({ field }) => (
                              <FormItem>
                                <FormLabel>Onward Location</FormLabel>
                                <SearchableDropdown
                                  value={field.value}
                                  searchTerm={onwardSearch}
                                  onSearchChange={setOnwardSearch}
                                  data={
                                    onwardLocationsData?.map((item: any) => ({
                                      value: item.servicePointId,
                                      label: `${item.barcode || ""}-${item.locationId}`,
                                    })) || []
                                  }
                                  loading={
                                    isFetchingOnward ||
                                    isFetchingHolding ||
                                    isFetchingIbOnward
                                  }
                                  onChange={(val) => {
                                    field.onChange(val);
                                    onOnwardLocationChanged(val);
                                  }}
                                />

                                <FormMessage />
                              </FormItem>
                            )}
                          />
                          {serviceType === "Interbranch Service" && (
                            <FormSelect
                              form={form}
                              data={
                                cashCenters?.map((item: any) => ({
                                  value: item.cashCenterId,
                                  name: `(${item.barcode || ""}) ${item.name}`,
                                })) || []
                              }
                              name="onwardCashCenterId"
                              label="Onward Cash Center"
                              placeholder="Select Cash Center"
                            />
                          )}
                          {serviceType !== "Interbranch Service" && (
                            <FormField
                              control={form.control}
                              name="onwardCustomerName"
                              render={({ field }) => (
                                <FormItem>
                                  <FormLabel>
                                    Onward Location Customer
                                  </FormLabel>
                                  <FormControl>
                                    <Input {...field} readOnly />
                                  </FormControl>
                                  <FormMessage />
                                </FormItem>
                              )}
                            />
                          )}
                        </>
                      ) : (
                        <>
                          {serviceType === "Kiosk Service" ? (
                            <FormField
                              control={form.control}
                              name="servicePointId"
                              render={({ field }) => (
                                <FormItem>
                                  <FormLabel>Location</FormLabel>
                                  <SearchableDropdown
                                    value={field.value}
                                    searchTerm={searchTerm}
                                    onSearchChange={setSearchTerm}
                                    data={mappedLocations}
                                    loading={isFetchingLocations}
                                    onChange={(val) => {
                                      field.onChange(val);
                                      onSourceLocationChanged(val);
                                    }}
                                  />

                                  <FormMessage />
                                </FormItem>
                              )}
                            />
                          ) : (
                            <FormField
                              control={form.control}
                              name="servicePointId"
                              render={({ field }) => (
                                <FormItem>
                                  <FormLabel>Source Location</FormLabel>
                                  <SearchableDropdown
                                    value={field.value}
                                    searchTerm={searchTerm}
                                    onSearchChange={setSearchTerm}
                                    data={
                                      sourceLocations?.map((item: any) => ({
                                        value: item.servicePointId,
                                        label: `${item.barcode || ""}-${item.locationId}`,
                                      })) || []
                                    }
                                    loading={isFetchingAutocomplete}
                                    onChange={(val) => {
                                      field.onChange(val);
                                      onCITSourceLocationChanged(val);
                                    }}
                                  />

                                  <FormMessage />
                                </FormItem>
                              )}
                            />
                          )}
                          <FormField
                            control={form.control}
                            name="customerName"
                            render={({ field }) => (
                              <FormItem>
                                <FormLabel>Customer</FormLabel>
                                <FormControl>
                                  <Input {...field} readOnly />
                                </FormControl>
                                <FormMessage />
                              </FormItem>
                            )}
                          />
                        </>
                      )}
                    </>
                  )}

                  {isBranchToATM || isBranchToATMUndefinedLocation ? (
                    <FormCombobox
                      form={form}
                      data={customerCITList?.map((cust: any) => ({
                        value: cust?.servicePointId,
                        label: `${cust.barcode}-${cust.locationId}`,
                      }))}
                      name="sourceSPId"
                      label="Bank Branch"
                      placeholder="Select Bank Branch"
                    />
                  ) : null}

                  <FormField
                    control={form.control}
                    name="serviceDateTime"
                    render={({ field }) => (
                      <FormItem className="space-y-2">
                        <FormLabel>Service Date</FormLabel>
                        <DatePicker
                          {...field}
                          placeholder="Pick a date"
                          selectedDate={field.value}
                          onSelectDate={field.onChange}
                          disabled={(date) => date < PREV_5_DAY_DATE}
                        />
                        <FormMessage />
                      </FormItem>
                    )}
                  />
                  <FormSelect
                    form={form}
                    data={invoicingModels}
                    name="invoicingModel"
                    label="Invoicing Model"
                    placeholder="Select Invoicing Model"
                  />
                  <FormSelect
                    form={form}
                    data={jobPriorities}
                    name="priority"
                    label="Job Priority"
                    placeholder="Select Job Priority"
                  />

                  <FormSelect
                    form={form}
                    data={jobNatures}
                    name="jobNature"
                    label="Job Nature"
                    placeholder="Select Job Nature"
                  />
                  <FormCombobox
                    form={form}
                    data={inRouteTeams?.map((m: any) => ({
                      value: String(m.routeNo),
                      label: `${m.routeNo} (${m.description})`,
                    }))}
                    name="routeNo"
                    label="Route"
                    placeholder="Select Route"
                  />

                  <FormField
                    control={form.control}
                    name="requestedBy"
                    render={({ field }) => (
                      <FormItem>
                        <FormLabel>Requested By</FormLabel>
                        <FormControl>
                          <Input
                            type="text"
                            placeholder="Select Requested By"
                            {...field}
                          />
                        </FormControl>
                        <FormMessage />
                      </FormItem>
                    )}
                  />
                  <FormField
                    control={form.control}
                    name="remarks"
                    render={({ field }) => (
                      <FormItem className="col-span-2">
                        <FormLabel>Remarks</FormLabel>
                        <FormControl>
                          <Textarea
                            placeholder="Write your remarks"
                            className="resize-none"
                            {...field}
                          />
                        </FormControl>
                        <FormMessage />
                      </FormItem>
                    )}
                  />
                </form>
              </Form>
            </CardDescription>
          </CardContent>
        </Card>

        <Card className="flex-1">
          <CardContent className="pt-6">
            <CardTitle className="text-lg">Request Review</CardTitle>
            <CardDescription className="mt-4">
              <h5 className="text-md font-bold">Source Location</h5>
              <div className="mt-2 grid grid-cols-3 gap-3">
                <div>
                  <label>Location ID</label>
                  <div className="border border-input mt-1 rounded-md p-2 min-h-9">
                    {sourceLocation?.locationId ||
                      sourceLocation?.servicePointId ||
                      ""}
                  </div>
                </div>
                <div>
                  <label>Location Name</label>
                  <div className="border border-input mt-1 rounded-md p-2 min-h-9">
                    {sourceLocation?.locationName || ""}
                  </div>
                </div>
                <div>
                  <label>Machine Type</label>
                  <div className="border border-input mt-1 rounded-md p-2 min-h-9">
                    {sourceLocation?.machineType || ""}
                  </div>
                </div>
                <div>
                  <label>Maker</label>
                  <div className="border border-input mt-1 rounded-md p-2 min-h-9">
                    {sourceLocation?.maker || ""}
                  </div>
                </div>
                <div>
                  <label>Model</label>
                  <div className="border border-input mt-1 rounded-md p-2 min-h-9">
                    {sourceLocation?.model || ""}
                  </div>
                </div>
                <div>
                  <label>Route No</label>
                  <div className="border border-input mt-1 rounded-md p-2 min-h-9">
                    {sourceLocation?.routeNo || ""}
                  </div>
                </div>
                <div>
                  <label>Site Limit</label>
                  <div className="border border-input mt-1 rounded-md p-2 min-h-9">
                    {sourceLocation?.siteLimit || ""}
                  </div>
                </div>
                <div>
                  <label>Service Days</label>
                  <div className="border border-input mt-1 rounded-md p-2 min-h-9">
                    {sourceLocation?.serviceDays || ""}
                  </div>
                </div>
              </div>

              {onwardLocation ? (
                <>
                  <hr className="border-b bg-accent my-4" />
                  <h5 className="text-md font-bold">Delivery Site</h5>
                  <div className="mt-2 grid grid-cols-3 gap-3">
                    <div>
                      <label>Location ID</label>
                      <div className="border border-input mt-1 rounded-md p-2 min-h-9">
                        {" "}
                        {onwardLocation?.locationId || "-"}{" "}
                      </div>
                    </div>
                    <div>
                      <label>Location Name</label>
                      <div className="border border-input mt-1 rounded-md p-2 min-h-9">
                        {" "}
                        {onwardLocation?.locationName ||
                          onwardLocation?.name ||
                          "-"}{" "}
                      </div>
                    </div>
                    <div>
                      <label>Location Type</label>
                      <div className="border border-input mt-1 rounded-md p-2 min-h-9">
                        {" "}
                        {onwardLocation?.locationType ||
                          (onwardLocation?.name ? "Cash Center" : "-")}{" "}
                      </div>
                    </div>
                    <div>
                      <label>Route No</label>
                      <div className="border border-input mt-1 rounded-md p-2 min-h-9">
                        {" "}
                        {onwardLocation?.routeNo || "-"}
                      </div>
                    </div>
                    <div>
                      <label>Site Limit</label>
                      <div className="border border-input mt-1 rounded-md p-2 min-h-9">
                        {" "}
                        {onwardLocation?.siteLimit || "-"}
                      </div>
                    </div>
                    <div>
                      <label>Service Days</label>
                      <div className="border border-input mt-1 rounded-md p-2 min-h-9">
                        {" "}
                        {onwardLocation?.serviceDays || "-"}
                      </div>
                    </div>
                  </div>
                </>
              ) : null}
              <hr className="border-b bg-accent my-4" />

              {cassettes?.length > 0 && (
                <>
                  <h5 className="text-md font-bold">Model Denominations</h5>
                  <ReplenishModelDenominations
                    denominations={cassettes}
                    type="single"
                  />
                  <hr className="border-b bg-accent my-4" />
                </>
              )}

              <Button
                type="submit"
                form="collection-form"
                disabled={isOrderPending}
                isLoading={isOrderPending}
                variant="secondary"
                className="w-full mt-5"
              >
                Submit
              </Button>
            </CardDescription>
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
}

function FormSelect({
  form,
  name,
  label,
  placeholder,
  data,
  onChange,
}: {
  form: UseFormReturn<z.infer<typeof formSchema>>;
  name: keyof z.infer<typeof formSchema>;
  label: string;
  placeholder?: string;
  data?: { name: string; value: any }[];
  onChange?: (e: any) => void;
}) {
  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{label}</FormLabel>
          <Select
            onValueChange={(e) => {
              field.onChange(e);
              onChange?.(e);
            }}
            value={field.value as any}
          >
            <FormControl>
              <SelectTrigger>
                <SelectValue placeholder={placeholder} />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              {data?.map((item) => (
                <SelectItem key={item.value} value={item.value}>
                  {item.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}

function FormCombobox({
  form,
  name,
  label,
  placeholder,
  data,
  onChange,
  disabled,
  ...props
}: {
  form: UseFormReturn<z.infer<typeof formSchema>>;
  name: keyof z.infer<typeof formSchema>;
  label: string;
  placeholder: string;
  data?: { label: string; value: any }[];
  disabled?: boolean;
  onChange?: (e: any) => void;
}) {
  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{label}</FormLabel>
          <Combobox
            value={field.value as any}
            setValue={(e: string) => {
              field.onChange(e);
              onChange?.(e);
            }}
            data={data}
            placeholder={placeholder}
            disabled={disabled}
            {...props}
          />
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
